import React, { type ReactNode } from 'react';
import styles from './Section.module.css';

interface SectionProps {
  id: string;
  title: string;
  children: ReactNode;
  className?: string;
  centered?: boolean;
}

export function Section({ id, title, children, className = '', centered = false }: SectionProps) {
  return (
    <section id={id} aria-labelledby={`${id}-title`} className={`${styles.section} ${className}`.trim()}>
      <div className={styles.container}>
        <h2 id={`${id}-title`} className={`${styles.title} ${centered ? styles.centered : ''}`.trim()}>
          {title}
        </h2>
        {children}
      </div>
    </section>
  );
}

